export default __webpack_public_path__ + "static/media/foo-b.0dfdde81.svg";